/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 */
export enum INLINES {
  HYPERLINK = 'hyperlink',
  ENTRY_HYPERLINK = 'entry-hyperlink',
  ASSET_HYPERLINK = 'asset-hyperlink',
  // RESOURCE_HYPERLINK = 'resource-hyperlink',
  EMBEDDED_ENTRY = 'embedded-entry-inline',
  // EMBEDDED_RESOURCE = 'embedded-resource-inline',
}
